<template>
  <div class="clinic-info-page">
    <header class="clinic-info-header">
      <div class="clinic-info-header-avatar">
        <img src="@/assets/patient/patient_cal.png" alt="">
      </div>
      <div class="clinic-info-header-text">
        <div class="clinic-info-header-date">{{ title_today }}</div>
        <div class="clinic-info-header-welcome">欢迎您使用本系统！</div>
      </div>
    </header>

    <el-row>
      <el-col :span="24">
        <div class="clinic-info-section">
          <el-card class="box-card clinic-profile-card" shadow="hover">
            <div slot="header" class="clearfix clinic-info-card-head">
              <i class="el-icon-card-header"></i>
              <span>基本信息</span>
            </div>

            <el-row :gutter="16" class="clinic-profile-row">
              <div class="clinic-profile-grid">
                <div v-for="(item, key) in clinic_profile_data" :key="key" class="clinic-profile-item text item">
                  <div class="el-col-tbl-key">{{ key }}</div>
                  <div class="el-col-tbl-val">{{ (key == '诊所联系电话' && isDemo) ? "******" : item }}</div>
                </div>
              </div>
            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>

    <el-row v-if="clinic_profile_data" class="clinic-cooperate-row">
      <el-col :span="24">
        <div
          class="clinic-cooperate-hint"
          :class="{ 'clinic-cooperate-hint--active': clinic_profile_data['合作状态/开始时间'] == '未合作' }"
        >
          {{ clinic_profile_data["合作状态/开始时间"]=="未合作"?"由于该诊所合作状态为未合作，无法查看更多详情数据，请开通合作后查看更多详情数据":"" }}
        </div>
      </el-col>
    </el-row>

    <el-tabs
      v-if="clinic_profile_data && clinic_profile_data['合作状态/开始时间'] != '未合作'"
      v-model="activeName"
      class="clinic-info-tabs"
    >
      <el-tab-pane label="诊所收入" name="first" :lazy="true">
        <ClinicBusinessFee></ClinicBusinessFee>
      </el-tab-pane>
      <el-tab-pane label="诊所处方" name="second" :lazy="true">
        <ClinicBusinessCF :clinic_profile_data="clinic_profile_data"></ClinicBusinessCF>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {getTime} from "@/utils";

import '@/assets/css/main.css';
import ClinicBusinessCF from "@/views/clinic/ClinicBusinessCF";
import ClinicBusinessFee from "@/views/clinic/ClinicBusinessFee";
import {Role} from "@/role";

export default {
  name: "ClinicInfo",
  data() {
    return {
      activeName: "first",
      clinic_profile_data: null,
      title_today: '2021-01-01',
      clinic_id: this.$route.query.clinic_id ? this.$route.query.clinic_id : '2046032423103238145',
      // clinic_id: '1650588070122270721',
      doctor_id: this.$route.query.doctor_id ? this.$route.query.doctor_id : '-1',
    }
  },
  computed: {
    isDemo: function () {
      return this.$store.getters.user_role === Role.Demo
    },
  },
  components: {
    ClinicBusinessCF,
    ClinicBusinessFee,
  },
  mounted() {
    this.get_clinic_profile();
    this.title_today = getTime();
    localStorage.setItem('clinic_id', this.clinic_id);
  },
  methods: {
    get_clinic_profile() {
      this.$http.get(process.env.VUE_APP_API_HOST + "/clinic_profile?clinic_id=" + this.clinic_id).then((res) => {
        console.log(res);
        this.clinic_profile_data = res.data.data
      })
    },
  }
}
</script>

<style scoped>
/* 诊所信息页容器 */
.clinic-info-page {
  min-height: 100%;
  padding: 0 22px 28px;
  box-sizing: border-box;
  max-width: 1400px;
  margin: 0 auto;
}

/* 顶栏：头像 + 日期 + 欢迎语 */
.clinic-info-header {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 18px 4px 20px;
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.clinic-info-header-avatar {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(104, 245, 185, 0.28);
  background: linear-gradient(145deg, rgba(104, 245, 185, 0.15), rgba(60, 63, 74, 0.9));
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.clinic-info-header-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.clinic-info-header-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.clinic-info-header-date {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.52);
  letter-spacing: 0.03em;
  line-height: 1.4;
}

.clinic-info-header-welcome {
  font-size: 18px;
  font-weight: 700;
  color: #f5f7fb;
  letter-spacing: 0.02em;
  line-height: 1.3;
}

.clinic-info-section {
  margin-bottom: 8px;
}

.clinic-info-card-head {
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.02em;
}

/* 基本信息卡片 */
.clinic-profile-card {
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 26px rgba(0, 0, 0, 0.16);
  overflow: hidden;
}

.clinic-profile-card :deep(.el-card__header) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding: 12px 18px;
  height: auto;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.18) 0%, rgba(0, 0, 0, 0.1) 100%);
}

.clinic-profile-card :deep(.el-card__body) {
  background: #363944;
  padding: 12px 16px 16px;
}

.clinic-profile-row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

/* 字段列表：两列自适应，避免 rigid 的 span=3/9 在窄屏错乱 */
.clinic-profile-grid {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.clinic-profile-item {
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  width: 50%;
  padding: 4px 10px 4px 0;
  gap: 8px 12px;
}

.clinic-profile-item .el-col-tbl-key {
  min-width: 100px;
  max-width: 42%;
  flex-shrink: 0;
  line-height: 1.35;
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.52);
  height: auto !important;
}

.clinic-profile-item .el-col-tbl-val {
  flex: 1;
  min-width: 0;
  line-height: 1.35;
  font-size: 13px;
  font-weight: 500;
  color: #f0f2f6;
  word-break: break-word;
  height: auto !important;
}

@media (max-width: 768px) {
  .clinic-profile-item {
    width: 100%;
    padding-right: 0;
  }

  .clinic-profile-item .el-col-tbl-key {
    max-width: 40%;
  }
}

/* 未合作提示 */
.clinic-cooperate-row {
  margin-top: 8px;
}

.clinic-cooperate-hint {
  padding: 0;
  border: none;
  text-align: center;
  font-size: 13px;
  line-height: 1.55;
  box-sizing: border-box;
}

.clinic-cooperate-hint--active {
  padding: 12px 16px;
  border-radius: 8px;
  color: #ffb4a8;
  background: rgba(255, 107, 107, 0.12);
  border: 1px solid rgba(255, 120, 100, 0.35);
}

/* 子页面 Tab */
.clinic-info-tabs {
  margin-top: 14px;
  margin-left: 0;
}

.clinic-info-tabs :deep(.el-tabs__header) {
  margin-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.clinic-info-tabs :deep(.el-tabs__nav-wrap::after) {
  display: none;
}

.clinic-info-tabs :deep(.el-tabs__item) {
  color: rgba(255, 255, 255, 0.62) !important;
  font-size: 15px;
  height: 46px;
  line-height: 46px;
  padding: 0 20px;
}

.clinic-info-tabs :deep(.el-tabs__item.is-active) {
  color: #fff !important;
  font-weight: 600;
}

.clinic-info-tabs :deep(.el-tabs__active-bar) {
  background-color: #68f5b9 !important;
  height: 3px;
  border-radius: 2px;
}
</style>
